var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoryBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "966px",
    height: "640px",
    viewBox: "0 0 966 640",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/storyBubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "storyBackground",
    transform: "translate(-166.000000, -120.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "storyBubble",
    transform: "translate(168.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Layer_16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218,6.3 C256.8,5.2 289.6,6.3 327.9,9.1 C424.4,15 533.3,16 630.2,16.7 C721.4,21.5 786.4,23.5 878.1,22.3 C901.3,21.8 939.9,39.2 945.6,69 C957.8,132.8 955.6,178.1 959.8,245.3 C953,249.1 943.4,254.2 935.2,259.5 C938.6,260.5 935.2,259.5 941.5,261.1 C948.2,265.6 956.2,271.1 959.9,275.3 C961.8,341.3 965,429.7 958,495.9 C956,515.3 955.6,534.7 943.5,551 C924.3,575.4 878.6,570 855.8,571 C811.7,573 771.4,567.2 746.4,569.3 C740.6,569.8 706.8,622 697.3,636.5 C685.6,617.9 682.6,589.8 675.9,567 C672.3,567 663.3,569.3 655.1,569.1 C585.4,570.4 497.7,575 427.4,577.3 C343.2,580 279.2,571.9 199.7,576.8 C164,578.7 120.2,571.9 84.8,572 C48,569.8 30.4,567.7 23.5,527.1 C29.4230178,521.354673 37.1001426,514.451635 43.684622,507.263613 C40.6478088,508.453547 30.9812639,512.108758 29.3,511.1 C27.327027,509.916216 17.6661249,495.789463 17.4053797,495.407875 L17.4,495.4 L16.7,493 L54.7467839,492.401836 C54.7645909,492.367884 54.7823296,492.333938 54.8,492.3 C43,491.3 34,493 16.6,492.9 C15.4,484.7 14.1,473.5 12.9,464.2 C22.9762424,458.766732 27.7827273,455.260829 32.3083646,451.440897 C29.4011317,452.704011 19.2,453.8 19.2,453.8 L19.2,453.8 L8.5,437.5 C8.5,437.5 14.4,437.4 16.7,437.2 C19,437 34.7,435.3 36.7,435.2 C38.3959441,435.115203 48.6486621,436.108991 50.6293318,436.352143 L50.7,436.3 L50.7,436.3 C32.8,433 25.3,437.6 8.4,437.4 C-5.2,341.3 20,242.9 18,146.5 C23.1545455,143.636364 26.6487603,139.922314 30.415402,136.208264 L26,139.9 L19,119.2 C19,119.2 19.1317524,119.254897 19.372671,119.355532 C19.1802456,119.261872 19.021186,119.176302 18.9,119.1 C22.3,94.1 31.8,67.3 36.6,43 C41.6,10.8 78.2,6.7 104.9,5.7 C141.5,0.2 181,3.2 218,6.3 Z M54.2561464,493.308548 L47.1094161,503.369017 C49.9274555,500.014223 52.403243,496.632056 54.2561464,493.308548 Z M50.464304,436.475086 L50.4008292,436.49892 C48.8035039,437.166525 44.1981888,441.078477 40.0932318,444.699019 C42.8116011,442.391346 46.0837915,439.733139 50.464304,436.475086 Z M21.802244,120.373608 L21.9873971,120.451715 C26.625,122.40216 35.1833333,126.033333 36.7,126.9 C38.2260261,127.772015 38.3262834,128.855255 38.2670875,129.382256 C39.9493995,126.867093 27.7788238,122.699712 21.802244,120.373608 Z",
    id: "Combined-Shape",
    strokeWidth: 3,
    fill: "#000000",
    opacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M937.5,251.1 C931.2,249.5 934.6,250.5 931.2,249.5 C939.4,244.2 949,239.1 955.8,235.3 C951.6,168.1 953.8,128.8 941.6,65 C935.9,35.2 897.72005,19.8479262 874.52005,20.3479262 C782.82005,21.5479262 717.4,17.5 626.2,12.7 C529.3,12 420.4,11 323.9,5.1 C285.6,2.3 252.8,1.2 214,2.3 C177,-0.8 135.854979,-2.19269047e-15 100.9,1.7 C74.2,2.7 37.6,6.8 32.6,39 C27.8,63.3 18.3,84.1 14.9,109.1 C17.6,110.8 39.1,117.1 33.5,120 C26.1,125.4 22.1,132 14,136.5 C16,232.9 -9.2,331.3 4.4,427.4 C21.3,427.6 28.8,423 46.7,426.3 C28.1,440.1 29.3,443.2 8.9,454.2 C10.1,463.5 11.4,474.7 12.6,482.9 C30,483 39,481.3 50.8,482.3 C44.5,494.4 29.5,507.4 19.5,517.1 C26.4,557.7 44,559.8 80.8,562 C116.2,561.9 160,568.7 195.7,566.8 C275.2,561.9 339.2,570 423.4,567.3 C493.7,565 581.4,560.4 651.1,559.1 C659.3,559.3 668.3,557 671.9,557 C678.6,579.8 681.6,607.9 693.3,626.5 C702.8,612 736.6,559.8 742.4,559.3 C767.4,557.2 807.7,563 851.8,561 C874.6,560 920.3,565.4 939.5,541 C951.6,524.7 952,505.3 954,485.9 C961,419.7 957.8,331.3 955.9,265.3 C952.2,261.1 944.2,255.6 937.5,251.1 Z",
    id: "STROKE_a7fa6f8c-2417-4b6f-90e7-c7928365710d",
    strokeWidth: 3,
    fill: "#46526E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.6,250.982422 C932.9,246.782422 911.1625,245 907.7625,244 C915.9625,238.7 927.1,231.5 933.9,227.7 C932.675,157.797632 932.675,122.64375 920.475,58.84375 C914.775,29.04375 896.6,21.5175781 873.4,22.0175781 C781.7,23.2175781 717.4,17.5 626.2,12.7 C529.3,12 420.4,11 323.9,5.1 C285.6,2.3 252.8,1.2 214,2.3 C173.2,4.27435864e-15 139.777894,1.12132525e-14 100.9,1.7 C74.2,2.7 37.6,6.8 32.6,39 C27.8,63.3 18.3,84.1 14.9,109.1 C17.6,110.8 39.1,117.1 33.5,120 C26.1,125.4 22.1,132 14,136.5 C16,232.9 -9.2,331.3 4.4,427.4 C21.3,427.6 28.8,423 46.7,426.3 C28.1,440.1 29.3,443.2 8.9,454.2 C10.1,463.5 11.4,474.7 12.6,482.9 C30,483 39,481.3 50.8,482.3 C44.5,494.4 35,501.6 25,511.3 C36.425,541.7 62.725,537.9 73.7,540.5 C109.1,540.4 148.7,542.131178 184.4,540.231178 C263.8,538.624407 331.352532,537.952138 415.651129,538.624407 C486,539.185429 547.2,537.737204 616.9,536.437204 C625.1,536.637204 669.1,535.5 672.7,535.5 C679.4,558.3 682.515625,578 686.7,594.585938 C696.2,580.085937 721.3,536 727.1,535.5 C752.1,533.4 796.225,542.95 840.325,540.95 C863.125,539.95 903.3,535.633926 920.475,526.475 C932.575,510.175 929.5,523.475545 931.5,504.075545 C931.699754,502.186445 935.023908,482.977188 935.1,481.05 C937.7,415.2 937,397.65 938.603782,338",
    id: "Inner",
    strokeWidth: 3,
    fill: "#506086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,109.2 L22,129.9 L34.2,119.7 C34.2,119.7 34.8,118.1 32.7,116.9 C30.6,115.7 15,109.2 15,109.2 Z",
    id: "Path",
    strokeWidth: 2.82,
    fill: "#46526E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,485.4 C13.4,485.4 23.3,499.9 25.3,501.1 C27.3,502.3 40.6,496.9 40.6,496.9 L50.9,482.4 L12.7,483 L13.4,485.4 Z",
    id: "Path",
    strokeWidth: 2.82,
    fill: "#46526E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,443.8 C15.2,443.8 27.3,442.5 28.9,441.1 C30.5,439.8 45,426.3 46.8,426.4 C48.6,426.5 34.7,425.1 32.7,425.2 C30.7,425.3 15,427 12.7,427.2 C10.4,427.4 4.5,427.5 4.5,427.5 L15.2,443.8 Z",
    id: "Path",
    strokeWidth: 2.82,
    fill: "#46526E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "inner",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,501 C22.9,544.9 92.5,526.4 122.2,529.6 C166.5,529.8 186.5,529.2 230.7,528.5 C371.7,528 499.7,529.4 640,524.5",
    id: "STROKE_007e9235-9a89-4615-960a-81cb7e6e2def",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.1,524.6 C644.3,524.3 650.5,524.8 654.7,524.8 C661.9,544.5 665.9,564.4 670.4,585.1 C678.4,565.6 696.5,540.5 711.7,526.1 C780.9,523 823.9,538.5 891.9,521.1 C921.2,514.6 919.1,470.3 920.2,445.6 C923.4,377.6 920.6,307.7 921.5,240.1 L905.9,236.1 C905.9,236.1 891.3,234.8 892.1,232.1 C893,229.4 916.5,219.7 919.1,216.6 L919.1,203.5 C917.1,152.2 918.1,104.702368 905,51.6023684",
    id: "Path",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.7,22.9 C861.6,22.9 861.6,25.9 859.7,25.9 C857.7,25.9 857.7,22.9 859.7,22.9 Z",
    id: "STROKE_ba2d8e52-7015-4bd7-81c7-37e26feec808",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.7,25.5 C868.7,25.4 868.7,25.3 868.7,25.1 L871,24.7",
    id: "STROKE_a191b454-f2a1-41c4-b592-e0855f68d7b1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.2,35.1 C882.1,35.1 882.1,38.1 880.2,38.1 C878.3,38.1 878.3,35.1 880.2,35.1 Z",
    id: "STROKE_d075675c-4d7d-44ad-b24f-a07f491bd919",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.1,48.6 C873,48.6 873,51.6 871.1,51.6 C869.1,51.7 869.1,48.6 871.1,48.6 Z",
    id: "STROKE_8fbcbcdd-47ef-4be6-befd-30060843b65b",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.7,55.8 C896.6,55.8 896.6,58.8 894.7,58.8 C892.7,58.8 892.7,55.8 894.7,55.8 Z",
    id: "STROKE_7d679d2c-b0ee-4817-ac1f-5bc8520aec2b",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888,30.1 C888.7,28.3 888.9,28.2 890.5,26.5",
    id: "STROKE_b35e2b42-2e72-467f-b652-42ee62d4f77b",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.9,511.3 C824.8,511.3 824.8,514.3 822.9,514.3 C820.9,514.4 820.9,511.3 822.9,511.3 Z",
    id: "STROKE_f45ae5a9-2762-4461-abd3-7437079910e4",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.9,513.4 C857.7,513.3 857.7,513 857.9,512.3",
    id: "STROKE_3da3a06e-53ee-404c-aeb4-8a4efbbaccd0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.3,486.9 C864,486.4 863.1,484.2 862.1,483.6",
    id: "STROKE_340d4ab1-17bd-4a80-88ef-add3b639c437",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.7,498.7 C879.2,500.1 878.7,499.9 881.2,502.3",
    id: "STROKE_9db68d8c-f03f-4c2a-bda8-83d997a6fa0e",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.2,503.9 C889.5,504.1 888.5,504.7 887.3,505.5",
    id: "STROKE_b97b8e90-ca26-48ac-a39a-05e8e89fa587",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.2,507.5 C871.1,507.5 871.1,510.5 869.2,510.5 C867.2,510.5 867.2,507.5 869.2,507.5 Z",
    id: "STROKE_d3aecd47-4a85-4aa9-a141-cccfe94e66aa",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.6,497.1 L898.8,496.8 C898.9,496.6 899,496.2 899.1,495.6",
    id: "STROKE_a1b06837-e234-4f3b-82df-472d33afeee5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.8,476.2 C898.1,476.2 896.5,476.2 894,476.3",
    id: "STROKE_5a10fd85-a07a-49d5-ba84-76a789b051ce",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.1,483.1 C882,483.1 882,486.1 880.1,486.1 C878.1,486.1 878.1,483.1 880.1,483.1 Z",
    id: "STROKE_4ce0e36e-1804-487c-85bb-7fca8c566772",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.8,448.9 C893.7,448.9 893.7,451.9 891.8,451.9 C889.8,451.9 889.8,448.8 891.8,448.9 Z",
    id: "STROKE_d9063e4f-e01e-4621-8577-e765d1ca3808",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,489.2 C33.8,489 33.9,489.7 33.6,491.1",
    id: "STROKE_56a62871-ebfe-44f7-83c2-24e42ca48a99",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,505.7 C51.3,505.7 51.3,508.7 49.4,508.7 C47.5,508.7 47.5,505.6 49.4,505.7 Z",
    id: "STROKE_acfe91f3-615d-41e7-b634-805502fb0d2f",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1,506.4 C69,506.4 69,509.4 67.1,509.4 C65.1,509.5 65.1,506.4 67.1,506.4 Z",
    id: "STROKE_d9c4a456-9728-4d2f-b4a6-dd9bcdf308ce",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2,505.3 C34.1,505.3 34.1,508.3 32.2,508.3 C30.2,508.3 30.2,505.2 32.2,505.3 Z",
    id: "STROKE_c32afaa6-e08a-4ed0-89a9-a47e3d9f92ec",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4,508.5 C31.2,507.9 31.6,507.7 32.2,506.8",
    id: "STROKE_9d1805d8-b9d6-4638-a33a-a234dd0a74da",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.7,382.6 L0.5,382.9 C1.1,383.3 2.1,382.7 2.8,382.6",
    id: "STROKE_c9d4d018-e3a9-4655-b554-1e29f157caf9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,376.5 C16.5,376.7 16.5,376.9 16.6,377",
    id: "STROKE_d86c4ab9-b15a-4273-acb5-9e6cb560e3bc_1_",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,368.2 C7,368.2 5.6,367.8 4.6,367.6",
    id: "STROKE_0a574ac3-9500-4634-a196-fc6f9b4a473d",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,340.4 L4.9,341.1",
    id: "STROKE_6d5f5142-7895-4143-b08d-cafa1c6cb27d_1_",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7,333 C4.8,333.9 5.3,333.8 6.1,334.8",
    id: "STROKE_12d3a40a-1be4-4ca6-80c2-689a4233d523",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6,119.2 C17.5,119.1 17.3,119.2 16.8,119.5 C17.2,119.5 17.8,118.6 18.2,118.3",
    id: "STROKE_120a1511-178c-4696-b06b-01097158b7ba",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "STROKE_fe3cd8cd-b4da-4224-8ca2-9130a5d701b4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "9.5 84.7 8.9 83.9 9.3 82.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "STROKE_5132af1c-a358-4f5e-b1a8-ed907f9111b0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "19.8 57 18 57.3 17.6 57.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,39.2 C20.9,39.2 20.9,42.2 19,42.2 C17,42.2 17,39.1 19,39.2 Z",
    id: "STROKE_048a2618-bf2c-4d97-870c-8546ebe72005",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,39.1 C19.8,39.2 19.2,40.3 19,40.7",
    id: "STROKE_3f8d93dd-d5fc-44c2-b318-ccdc5c17abe9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,27.5 C25.1,27.5 25.1,30.5 23.2,30.5 C21.3,30.5 21.3,27.5 23.2,27.5 Z",
    id: "STROKE_2a9cace3-4047-4527-a609-47f2a0badcf4",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,13.9 C24.9,13.9 24.9,16.9 23,16.9 C21,16.9 21,13.8 23,13.9 Z",
    id: "STROKE_9f36b585-6fb3-4cb7-a7c9-c62c2e6ecbc2",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4,4.9 C42.2,4.9 41.3,4.9 40.3,5.4",
    id: "STROKE_20ee7153-3f7c-4720-ad40-626c283650eb",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,0.1 C47.2,0.1 47.2,3.1 45.3,3.1 C43.4,3.1 43.4,0 45.3,0.1 Z",
    id: "STROKE_7955dec7-6a98-4fd4-aa1c-1cccda44b5de",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,433.7 C13.4,433.7 13.4,436.7 11.5,436.7 C9.5,436.7 9.5,433.7 11.5,433.7 Z",
    id: "STROKE_275f017c-0bda-4f3f-afa1-51720a559190",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,445.4 C20.9,445.9 20,446.6 18.6,447.7",
    id: "STROKE_4ca7a3cb-6e98-4b33-8a73-63ca3f09c338",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,355.9 C20.1,355.9 20.1,358.9 18.2,358.9 C16.2,358.9 16.2,355.8 18.2,355.9 Z",
    id: "STROKE_b1691e73-3d0c-4972-8da6-4a6c936d4b7f",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3,44.1 C38.2,44.1 38.2,47.1 36.3,47.1 C34.4,47.1 34.4,44.1 36.3,44.1 Z",
    id: "STROKE_9a9d3dbe-519d-4696-8c58-2525580cf7be",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,34.8 C31.7,34.8 31.7,37.8 29.8,37.8 C27.9,37.8 27.9,34.8 29.8,34.8 Z",
    id: "STROKE_71a26eb2-882d-4c6e-9673-ad02933fc312",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,13.9 L32.2,13.5 C32.4,13.3 32.7,12.8 32.7,12.3",
    id: "STROKE_751eee6a-f46a-445c-91ac-2908c63bdf41",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.9,14.6 C872.5,14.3 872,14.8 872,13.7",
    id: "STROKE_b1de2e58-64bb-4e01-b1ea-867ba94597c9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.8,12.5 C838.7,12.5 838.7,15.5 836.8,15.5 C834.9,15.5 834.9,12.4 836.8,12.5 Z",
    id: "STROKE_349ba9f6-315e-46de-abb6-8c6fe06196b9",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.1,129.2 C883,129.2 883,132.2 881.1,132.2 C879.1,132.2 879.1,129.1 881.1,129.2 Z",
    id: "STROKE_5fc1ab3d-6585-4104-947b-d176c03f59a7",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.9,146.8 C907.8,146.8 907.8,149.8 905.9,149.8 C904,149.8 904,146.7 905.9,146.8 Z",
    id: "STROKE_da6bf8b3-edc9-4957-ac6a-46dbee52db49",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.6,195.9 C891.5,195.9 891.5,198.9 889.6,198.9 C887.7,198.9 887.7,195.9 889.6,195.9 Z",
    id: "STROKE_6be55242-f85a-4c99-b5e6-c4af1eb80736",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.6,206 C898.5,206 898.5,209 896.6,209 C894.7,209 894.7,205.9 896.6,206 Z",
    id: "STROKE_db58024d-8700-4642-ba85-d129b14af95d",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "STROKE_f0593521-d09f-48fb-ab24-fec60f98e7e1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "886.2 358.7 885 358.6 885.1 358.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.7,396.5 C900,396.9 899.4,397.3 899,397.8",
    id: "STROKE_8291650d-822f-488e-a4c9-c21bdea418fc",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.5,316.1 L907,315.8 C907,315.1 907.4,315.3 907.4,314.6",
    id: "STROKE_e49fb492-8f15-49c5-9eb7-ec41b992e754",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5,504.4 C113.4,504.4 113.4,507.4 111.5,507.4 C109.6,507.5 109.6,504.4 111.5,504.4 Z",
    id: "STROKE_5bf16700-db79-40c5-a1b6-e75948d9bc37",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7,505.6 C111.4,505.6 111.4,505.6 111.6,505.6 L111.5,505.9",
    id: "STROKE_664493e0-7121-428b-bbac-53d7754e68e5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1,505.7 C91.2,505.7 90.3,504.8 90.8,506.6",
    id: "STROKE_9e380139-16b0-4a10-aa7a-fc00428da984",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.8,512.2 C183.7,511.9 184.6,512.1 186.4,512.8",
    id: "STROKE_9b82b0ce-2427-4ca2-9ec2-77146e650cb3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shading",
    transform: "translate(13.000000, 33.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8,490.7 C18.8,490.7 20.7,495 20.5,494.5 C23.8,501.2 25,506.1 28.4,513.2 L28.6,513.3",
    id: "STROKE_e193056a-98d8-4231-9594-13d44d80a1b9",
    strokeWidth: 2.4148
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,503.3 C38.8,515.1 36.3,511.5 43.3,522.1",
    id: "STROKE_6381dac7-1eda-4555-99ca-26df1771f044_1_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4,507.2 C43.1,510.3 53.2,522.3 55.1,526.4",
    id: "STROKE_e6a3057e-6af7-4aa4-9efd-85151afe17bf_2_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,508.4 C61.9,515.3 63.9,517.9 66.9,524.1",
    id: "STROKE_45d93585-60cd-4cd6-8976-db74d3084c0d",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,508.9 C72.6,515 77.2,521.5 80.2,526.7",
    id: "STROKE_221e5fe3-115b-454d-aa14-7791424be102",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9,509.2 C81.5,514.1 86.4,519 87.9,523.4",
    id: "STROKE_43b77f1e-2c76-4d3f-ac4f-2dd54532e29c",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,511.6 C93,516.6 97.5,524.2 99.5,528.9",
    id: "STROKE_aeb55301-3899-4553-97c5-2635cec73f9f",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,509.2 C101.6,513.4 106.7,521.4 109,524.8",
    id: "STROKE_df9f07a6-8d7f-432c-93d3-57cb1b9e1301",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,512 C112,512.2 112.1,512.7 112.1,512.9 C112.2,513.5 113.5,516.2 116,521.1 C118.5,526 119.9,528.7 120.2,529.2",
    id: "STROKE_c1feec2f-0fce-4db6-8334-278c7374e116",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,510.9 C121.6,511.2 130.8,525.9 130.7,525.6",
    id: "STROKE_472cf348-8aa9-4fdc-8685-143adbc63804",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,511.7 C134.2,517.1 137.8,522.5 142.2,529.6",
    id: "STROKE_bc68b266-537a-4cb1-9a46-76aacc4cfe94",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4,513.3 C144.8,517.9 148.4,526.2 151,529.9",
    id: "STROKE_abfb9835-4dac-412a-952c-84241ac39fdd",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,512.8 C152,515.5 152.7,516.6 156,521.5",
    id: "STROKE_62e46bbd-c04c-4bc8-9809-2b963a7f5924",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1,527 C159.8,527.9 160,528 161.3,529.7",
    id: "STROKE_ca011454-48c9-4c93-83dd-53f58d04819d",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.2,514.8 C163.4,515.4 171.2,528.6 171.4,528.8",
    id: "STROKE_00e2a810-8f44-4f64-92e8-4ecd0d344374",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7,512 C170.3,517.6 174.1,523 177.2,529",
    id: "STROKE_5d6bcd8a-0745-42ec-9743-c8643a7bb3cc",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,513.6 C180.1,518.4 185.8,525.5 188.4,530",
    id: "STROKE_8b54aa84-d7e4-4776-b12c-d5baf730de39",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2,510.3 C186.8,516.3 190.9,523.4 195.3,527.7",
    id: "STROKE_98be2e9f-0983-46c3-90d4-472059ebab04",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.6,512 C196.1,517.7 200.4,523.1 204.2,529",
    id: "STROKE_960dec91-5f97-4b34-8fd1-1cce8d5c2b9b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.9,511.9 C205.4,516.9 210.2,524.9 213,529.1",
    id: "STROKE_111a9ff9-9e70-4245-bce6-6b94c7654736",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,511.9 C213.4,518.3 217.2,523.5 221.6,529.9",
    id: "STROKE_c1f511fe-80b9-4a7e-8ae2-e9e7adad741a",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,511.4 C221.5,516.9 227.5,526.6 230.3,531.4",
    id: "STROKE_0d7f3dcc-9e2c-4b4a-b761-dcca1b31559f",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,511.5 C228.2,512.4 239.4,530.2 239.5,530.5",
    id: "STROKE_4514e242-0be1-4584-ad83-daa9e466d548",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,513.5 C241.1,519.7 243.8,523.1 247.6,532",
    id: "STROKE_88344cb7-bf93-4f07-8326-d7b14028e002",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3,512.8 C247.8,516.7 252.4,524.8 255.3,527.9",
    id: "STROKE_080ac8c8-b76e-4e9d-aa16-da99a6d46a31",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.7,513 C261.1,518.2 265.3,524.2 271,531.6 C271.1,531.4 271.1,531.3 271.2,531.2",
    id: "STROKE_1c84cc44-4849-4456-9dec-a17b20e0d381",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,510 C270.2,516.1 274.2,524.8 279.9,528.8",
    id: "STROKE_ffe7a37c-ed92-423b-9683-f5ddfe0948c0",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.3,509.6 C277.6,514.4 284.1,529.6 290.2,533.5",
    id: "STROKE_bc14a721-2c4c-4ef1-9d5d-dc372738d2ba",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,511.6 C290.4,520.5 293.7,525.5 300.5,532",
    id: "STROKE_69b30388-df61-4d7b-8dc6-c3207352c317",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.4,513.6 C298.8,517.8 304.3,524.8 311.2,534.7",
    id: "STROKE_388c4777-f906-471b-8e56-3c4b38c7e7f5",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2,511 C310.1,518.4 315.1,527.9 320.4,534",
    id: "STROKE_e0bbd098-23f0-43fb-9af3-da2c8e3981db",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.5,511.7 C320.8,517.1 327.8,524.8 330.5,530",
    id: "STROKE_82c483b5-86be-45f4-afd1-f2df87686f37",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5,511.1 L326.5,511.1 C325.9,510.4 340.1,532.8 339.6,532",
    id: "STROKE_9919265f-9ffd-4a3f-9192-54d7c9affe0a",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,512.2 C337.7,519.7 345.3,527.1 348.9,533.4",
    id: "STROKE_cf7e845f-2f30-4b49-8196-15f34e259941",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.7,511.1 C344.5,512.8 348.2,518 349,519.7 C351.4,523.6 352.8,528.2 356,531.3",
    id: "STROKE_1a9fc21e-341b-445c-9055-40fd23a61bbc",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,514.4 C355.1,520.2 361.4,528.1 364.4,533.4",
    id: "STROKE_dc1a527a-9c6f-443e-9e25-5f7a156501a8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.6,513.7 C362.8,519.3 368.4,526.6 372.3,530.7",
    id: "STROKE_bcbb9cbd-6bf3-4937-b5ff-076163ebcab7",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.2,511.4 C369.7,517.2 376.4,525.5 380.1,529.7",
    id: "STROKE_27e16e01-370b-4abc-b5a3-de455ca826f8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8,512.1 C379.3,518.3 387.6,525.6 389.9,531.2",
    id: "STROKE_28b97d87-1985-419a-a80e-61920c12d06b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,513.7 C388.5,519.1 394.5,525 396,530.1",
    id: "STROKE_814573c1-87cd-45ad-bbb8-72b9754f6cc5",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.1,513.6 C396.3,519.3 403.6,524.9 405.4,530.5",
    id: "STROKE_39178b4e-d91b-4ba5-8ccd-4f4a04886ea7",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,512.9 C406.4,518.7 413,525.3 415.6,530.6",
    id: "STROKE_e0ab4219-ede9-4aea-9f89-19e0b68951a3",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.4,511.8 C422.4,516 426.9,521.5 430.4,526.2",
    id: "STROKE_5831571e-e70e-40bb-b2cc-94adbc0bafe3",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,510.3 C428.2,514.7 436.7,522 438.9,526",
    id: "STROKE_fc8bb7a2-a639-45ec-b23d-0a3906137102",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.2,508.4 C435.9,512.2 439.4,513.7 442,516.9 C443.9,518.7 448.6,525.4 449.8,527.1",
    id: "STROKE_01c740a1-0e3d-45f1-99e6-8ffe828ad8ab",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.4,511.3 C450.1,516.3 456.7,521.9 460.6,527.1",
    id: "STROKE_871d67ce-25c6-47ed-bdcf-7794593a8dee",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,511.1 C459.4,516.3 465.8,521.6 468.9,526.5",
    id: "STROKE_b5db8243-f2c3-41d2-aaf9-a0bdfc1451a3",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.1,513.5 C468.8,519.5 472,520.1 476.8,527.1",
    id: "STROKE_532bcc09-3acd-4016-8d46-2ba12c1f7531",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.8,512 C477.8,518 479,518.2 485.7,528.5",
    id: "STROKE_ee46b8ee-7f95-4575-be12-5bf3b4c5f497",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.5,509.8 C490.4,514.3 495.4,521.5 498.8,526.4",
    id: "STROKE_4ee5c14f-a917-4372-b3d4-bfa5c50ae999",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.8,505.9 C495.3,512.5 503,519.9 506.1,526.9",
    id: "STROKE_b3ae224d-e3d2-4d05-a1a4-3ba382f7f036",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.6,507.5 C507.1,514.7 515.2,523.3 519.7,529.8",
    id: "STROKE_3bc544b1-20c8-4362-9225-383a1bf0925b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.2,511.3 C514.2,511.2 514.3,511.2 514.4,511 C518.3,514.8 526.2,523.4 530.4,527.1",
    id: "STROKE_9e309b9f-42f5-4cf1-bab2-ff5ba8ec05d2",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.1,506.3 C525.5,513.1 533.7,519.1 538.3,525.2",
    id: "STROKE_b6f5da1a-6232-413e-8470-7746414e3d14",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.3,504.9 C531.9,511.8 544,521.7 548.3,527",
    id: "STROKE_73ea4de7-5c4b-48d7-82dc-b2fbe2e4f8ed",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.3,506.8 C545.6,514.3 552.7,522.7 558.7,528.3",
    id: "STROKE_00255ff4-b936-4382-8f3d-c94633e6b84b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.6,508.9 C553.9,512.5 562.7,520.2 565.3,522.9",
    id: "STROKE_7f5aacfc-35ce-4148-8c80-ebf2670b374f",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,507.9 C563.5,513.6 568.9,519.9 573,524.7",
    id: "STROKE_5fa26f4e-a207-4e1a-b6a7-d643c0700c5a",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.4,508.7 C572.4,513.8 578.3,518.2 581.6,521.8",
    id: "STROKE_096235b4-344c-4acd-8d4d-2bda4eb04f58",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.7,508.3 C585.8,512.3 592.5,517.7 595.4,522",
    id: "STROKE_33e971bb-b737-4ef3-b422-66f9eb602db2",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.6,506.5 C594.6,513.1 599,516.9 603.9,523.8",
    id: "STROKE_43699e80-94b8-4314-9a20-440f2d704d1c",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,508.4 C602,513.6 608.6,521.7 612.8,525.3",
    id: "STROKE_6e974147-b566-4040-8dd6-02552d92c411",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.5,506.6 C604.3,507.9 617.2,521.7 617.8,522.4",
    id: "STROKE_684fb4e9-0ab8-45ad-ad4b-e8fd90460488",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.6,506.3 C617.4,511.4 624.7,517.6 627.3,522.9",
    id: "STROKE_88da18d4-1a11-444a-b2c7-70d6f92808b8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.3,504.1 C624.3,508.1 633.6,519 635.9,522.9",
    id: "STROKE_69ff0e22-b090-4745-ad4c-f44778c7d4d3",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.6,504.1 C646,507.1 652.2,515.4 653.7,518.4",
    id: "STROKE_69ff0e22-b090-4745-ad4c-f44778c7d4d3_1_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.5,504.6 C631.6,508.9 636.1,513 638.9,516.9",
    id: "STROKE_d8b55def-301a-4946-924a-70eb0782943e",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.3,504.6 C652.4,508.9 656.9,513 659.7,516.9",
    id: "STROKE_d8b55def-301a-4946-924a-70eb0782943e_1_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.9,514.1 C707.9,514 707.7,514.1 707.6,514.1 C709.5,517.9 717.2,530.7 719.4,534.3",
    id: "STROKE_8df7dd0a-3ddf-4d5f-b6d8-3de6de4245d5",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.1,506.7 C714.8,513.5 722,522.2 725.9,527.6",
    id: "STROKE_055f6a57-c17e-4ba0-878f-e7e63a314597",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721,506.3 C723.6,514.7 728.8,518 733.3,525.7",
    id: "STROKE_86839b04-c4d1-44f2-995c-652060ed984b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.4,506.9 C729.1,512.7 737.7,520.9 741.3,524.7",
    id: "STROKE_dcb5bb00-59bc-40e2-bce3-bbeabee09ba1",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.3,504.8 C738.3,505.3 747.1,518 751.3,524.1",
    id: "STROKE_fa33373f-312a-4325-94bb-a728992d41e1",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.3,505.4 C747.5,510.4 758.9,522.8 761.4,526.9",
    id: "STROKE_fb0ac9e0-e4cc-4f41-8134-68422ec67d67",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759,510.5 C757.1,512 770,524.9 770.2,525.2",
    id: "STROKE_bae92279-2d6d-4aee-bc73-cff09cbcc240",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.8,510.8 C773.4,515.9 780,521.3 782.4,526.8",
    id: "STROKE_3eb9a76d-6660-4663-9a95-cb6d3e8c40ce",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.9,509.6 C779.8,515.6 787.5,522.3 791,527.4",
    id: "STROKE_056dcee5-215a-40ee-9c23-799e58676c33",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.2,509.5 C790.2,515.5 795.7,519 800.4,525.7",
    id: "STROKE_5038f62a-f293-4667-939e-99699d8eaf5d",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800,512.3 C801.5,517.7 807.4,523.1 810.5,527.8",
    id: "STROKE_27f667f3-098e-499f-abae-bf51f0621e7d",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.8,513 C813.7,517.4 816.2,520.7 820.5,525.8",
    id: "STROKE_876c0e5e-9e39-4ee6-b4e4-c4fb525ee02d",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.4,510.2 C821.5,515.9 830.6,522.1 834.4,526",
    id: "STROKE_3780babf-b625-4bf0-9bd0-c2d596b769b6",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.3,509.6 C834.3,514.9 841.3,523.6 845.6,527.2",
    id: "STROKE_ed32fc0b-a248-4066-90a2-8e47d5ca9b49",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.1,511.8 C839.2,512.1 849.3,526.9 849.3,526.8",
    id: "STROKE_4dfc29ef-bb29-4953-a816-a53869b96d68",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.2,511.2 C851.9,514.7 859.6,523.2 861.9,525.6",
    id: "STROKE_6ab7686d-d888-4d68-9f4b-5b39919c19b7",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.4,513.3 C862.1,517.1 867.6,521.7 869.8,524.7",
    id: "STROKE_d22bce49-ecdd-408e-87be-9a2fcec8b462",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.1,508.4 C868.4,508.5 878.3,522.9 878.3,522.7",
    id: "STROKE_7494acf9-bc16-4e30-9de0-4a0bbc13a992",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.2,511.2 C879.2,511.1 878.9,510.8 878.5,510.4 C879.9,513.6 886.6,522 889.2,524.3",
    id: "STROKE_4f2a3868-143f-4c30-a3cd-753ede3aee84",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.8,505.7 C888.6,510.3 895.6,518.9 899.2,522.8",
    id: "STROKE_3039cebf-2e48-4c4b-b1e0-ebc8726780fa",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.7,505.1 C898.4,509.8 904.8,515.5 907.6,520.1",
    id: "STROKE_7270e169-c7ac-4f4e-86a6-5b88cb223b74",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.7,505 C906.6,508.3 908.2,509.9 913.5,514.7",
    id: "STROKE_46c8095a-38ea-4ad4-9f4b-15b1559f7dca",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.6,500.5 C911.2,501 918.3,509.2 918.4,509.3",
    id: "STROKE_dc378ba7-d9d6-476b-affd-07f0129a061b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.9,491.8 C921.4,493.7 923.6,497.8 925.2,499",
    id: "STROKE_5cae2944-f44c-40e3-b9b2-0d7074e784a8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.1,482 C923.2,485.3 925.9,489.2 928.3,491.6",
    id: "STROKE_add0bd95-d8b1-4e34-bb97-0c1d748180ce",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.7,468.2 C925.5,470.1 928.8,476 929.9,477.9",
    id: "STROKE_bede7010-23ad-4667-92af-21de558d000a",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.5,459.2 C928.3,461.9 929.6,465.6 931.3,468.1",
    id: "STROKE_66f60f01-0781-4c5b-9d3c-a3dc21edf951",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.4,443.6 C926.2,444.3 930.1,452 930.4,452.5",
    id: "STROKE_c1aa0f9c-1101-42b5-9e3a-ad2c3338b648",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.3,430.8 C928.5,434.1 930.7,438.6 933.2,441.6",
    id: "STROKE_5499099f-755f-455a-8f5e-e219177af47b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.8,418.1 C929.6,420.7 933.4,429 935.2,431.2",
    id: "STROKE_91039ab8-6ad9-4f65-a1b7-0a46c9a8637e",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.6,404.5 C931.1,407.3 934.2,414.7 935.9,417",
    id: "STROKE_2b79ae7e-9a18-430f-a0ff-aac833d54ace",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.7,565.8 C674.7,571.5 678.9,588.4 680.4,593.6",
    id: "STROKE_def6c25c-86e9-4bf2-b673-203ba9142c11_1_",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.4,551.1 C680.4,551.9 681.5,555.6 683.8,562.4 C686.1,569.1 685.8,575.7 686.1,576.2",
    id: "STROKE_a6332aed-4e80-444f-baea-1a2630b0eaf2",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.6,538.9 C688.5,545.2 691.3,554.9 693.6,559.8 L694,559.8",
    id: "STROKE_6f318786-073e-4ce3-9075-fb5f06ff3cdc",
    strokeWidth: 2.4867
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.6,527.5 C698.1,532.4 701.7,544.1 706,546.9",
    id: "STROKE_08a99837-4510-4aac-b88a-23644f729ef0_1_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.1,520.1 C700.8,525.1 703.2,526.1 709.7,537.9",
    id: "STROKE_77d9c6b6-b718-4f5b-8793-5d2f3b2f95d8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.9,502.5 C638,502.8 646.4,518.4 646.3,518.4",
    id: "STROKE_e6df8006-5b2d-41f4-b782-bdb8be4b44f2",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.9,396.4 C931.8,397 932.6,397.7 934.3,399.9 C935.9,401.9 936.8,403.1 937.2,403.6",
    id: "STROKE_33ea5ed4-aa2a-44af-8ded-4870dc73a223",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.5,388.3 C931.8,390.8 937.3,394.4 938.9,396.3",
    id: "STROKE_0716993e-ffdc-47a7-a2b2-d5e3ecd56355",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.7,379.4 C931.7,379.5 933.5,381.4 937.1,385",
    id: "STROKE_14b9cd0f-eca0-43df-8c49-571cbb0a5ac7",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.7,369.4 C932.5,372.2 935.2,374.6 938.1,378.1",
    id: "STROKE_9102fbd1-2adb-4cfc-a0a8-23bd213f500c",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.8,359.4 C932,363.2 935.8,367.1 938.7,369.9",
    id: "STROKE_6af97d48-957d-453b-b606-b1715811397b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.2,347.6 C932.6,350.3 935.9,355.1 938.3,356.9",
    id: "STROKE_995227b6-afb4-4253-9ce8-72859d377d35",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.9,335.8 C933.2,339.1 935.5,342.2 939.2,345.7",
    id: "STROKE_13a505ca-7814-4307-9c37-ff3fdab69ec0",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.6,321.9 C930.9,324.4 935.2,328.5 937.2,329.6",
    id: "STROKE_002ca34b-4de2-4a4e-a5a4-1d22c063cea8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.1,310.5 C933.4,314.1 936.5,318.6 938.8,321.1",
    id: "STROKE_677b428b-3e24-4092-8316-fda340a11f8d",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.6,295.8 C930.3,296.8 937.2,304.5 937.7,305",
    id: "STROKE_e24fa09a-2641-48ce-963c-6a5f11a78546",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.3,283.6 C931.1,288.1 933.4,291.4 938,296.7",
    id: "STROKE_a897e376-3a6b-42b5-886d-28080137d0c5",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.1,273.1 C929,275.5 935.1,282.5 936.5,284.1",
    id: "STROKE_9af6c36e-9b0b-4fa9-8f4c-5bb2011c0e74",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.5,260.3 C930.9,263.5 935,270.7 936.8,273.4",
    id: "STROKE_79dc488a-2317-4c66-a409-bcef5ee67cd8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.1,252.3 C929.6,252.6 936.4,259.8 936.5,259.8",
    id: "STROKE_54832e4b-8df1-4e38-a449-993bb802bfff",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.1,238.9 C929,241.3 935.1,248.3 936.5,249.9",
    id: "STROKE_9af6c36e-9b0b-4fa9-8f4c-5bb2011c0e74_1_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.1,229.1 C929.6,229.4 936.4,236.6 936.5,236.6",
    id: "STROKE_54832e4b-8df1-4e38-a449-993bb802bfff_1_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.1,194.7 C924.3,197.8 939.7,199.9 942.9,202.3",
    id: "STROKE_3d8083cd-e511-48bd-9c71-531605aa0cf8_1_",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.4,176.8 C926.7,180 928.8,181.4 931.9,184",
    id: "STROKE_3475ea57-0182-4929-a5e0-7fbc3e632959",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.5,161.9 C927.5,165.9 932.8,170 935.7,173.9",
    id: "STROKE_8b47c5ed-c18c-413e-ac88-b8866338bc46",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924,145.4 C925.5,148.3 930.6,154.7 934,158",
    id: "STROKE_d8717ada-ad5d-435f-995a-1b5ae4767a69",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.6,132.7 C927.9,137.1 933.7,143 937.4,145.5",
    id: "STROKE_48006f0a-e223-4bc1-b7e1-8910ec1b17aa",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.6,119.3 C924.2,121.2 926.7,123.2 934.4,130.8",
    id: "STROKE_35c6daee-1139-4916-a291-fc0de6f818dd",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.7,99.8 C923.8,104.7 928.3,110.7 932.8,113.5",
    id: "STROKE_9cf76516-7964-49a3-b01c-a68e6135799b",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.3,82 L918.4,82.1 C917.7,82.3 933.3,97.5 932.9,97.3",
    id: "STROKE_2abfd013-be05-4dc8-8938-18c9207005a2",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.3,71.4 C922.5,73.7 929.8,79.7 931.8,82.2",
    id: "STROKE_1fec0835-0a55-4fd7-8743-5b9d85aa5d70",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.4,61.8 L920.5,61.9 C923.2,62.4 931.8,70.3 933.9,72",
    id: "STROKE_462e8904-1780-4203-8f2f-9f77c9e8a8fd",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.5,48.1 C919.9,51.7 930,57.7 932.8,60",
    id: "STROKE_ec31f936-7fa7-4a94-9c83-722ad5e31a81",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.3,35.2 C918.4,38.6 926.8,44.3 930.1,47.7",
    id: "STROKE_087b7f88-d207-4595-a3dd-ed245f03f593",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.8,16.3 C914.5,23.3 924.7,29.5 931,35.8",
    id: "STROKE_b33ce7b2-7d43-4b5e-aafe-e32ed1b798ff",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904,0.6 C904.8,1.8 906.2,2.6 911,6.3 C915.3,9.5 917.7,11.3 918.3,11.7",
    id: "STROKE_9bb1ddcb-b46b-498e-b1a7-1ac795624e17",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.3,207.3 C906.1,208 911.9,210.6 912.4,211",
    id: "STROKE_4ae915b8-592c-4108-812f-66cec8564140",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.4,204.3 C912.2,206.1 915.8,207.8 917.5,209.6",
    id: "STROKE_770815f4-5dae-470c-b70a-3063a4e5d52c",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.9,200.6 C917.1,202 922.6,206.5 924,207.9",
    id: "STROKE_6f3e2d42-a554-4655-8933-e160e065c946",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.4,198.5 C920.5,199 929.4,205 929.8,205.4",
    id: "STROKE_94a53d70-f61d-4a22-a734-024a752f758d",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4,396.4 C1.5,398.1 6,403.9 7.5,405.6",
    id: "STROKE_e2cffbec-746f-484a-84bc-d6b183272881",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,395 C9.7,396 10.5,398.9 15.3,404",
    id: "STROKE_bb19555c-1c2a-448d-b77b-70e5e6d67825",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6,395 C18.7,398.3 18.4,397.4 21,400.6",
    id: "STROKE_b792c12d-8f69-420e-87a7-1bc9b4e7b481",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,454.3 C9.9,456.8 14.7,461.2 16.6,462.9",
    id: "STROKE_c1206d43-0957-468e-a00e-926deeab23dc",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,450.3 C15.4,451.1 17.2,454.7 20,458.3",
    id: "STROKE_1c8d6662-1f27-4ec0-a4ec-0173cfda0da8",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4,449.7 C23.3,452.7 23.5,453.2 27.6,457.8",
    id: "STROKE_b7da2f1d-ab12-4473-a67a-6bfbd0b2bd1e",
    strokeWidth: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,80.8 C10.3,83.2 10.2,83.4 13.3,89",
    id: "STROKE_92649629-f1a8-4c68-869e-ed56dcfee0d9",
    strokeWidth: 2.82
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryBubble);
export default __webpack_public_path__ + "static/media/storyBubble.2b3eb0140cef2533f0f05d6e150fbeed.svg";
export { ForwardRef as ReactComponent };